<template>
  <div class="page page-buses">
    <img class="page-banner" src="../../assets/banners/bikehall.jpg">
    <div class="page-header">
        <div v-if="page">
            <h2>{{ page.name[language] }}</h2>
            <img class="page-image" src="../../assets/pages/bikehall.png">
        </div>
    </div>
    <div class="page-description flex">
        <WFPageContent :page="page"></WFPageContent>
        <button class="btn btn-border btn-lg" @click="showRoute('poi', 'bikehall')">
            <WFIcon name="path"></WFIcon>
            <WFTranslate k="show_path">Show route</WFTranslate>
        </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        page: {
			type: Object,
			default: null
		},
    },
    computed: {
		...mapState('wf', ['language'])
	},
    watch: {
        page () {
            console.log('page', this.page)
        }
    },
    methods: {
        showRoute (type, slug) {
            this.$emit('showRoute', type, slug)
        },
        viewOnMap (type, slug) {
            this.$emit("viewOnMap", type, slug);
        }
    }
}
</script>

<style lang="less">
    .page-buses {
        .page-header {
            display: flex;
            flex-direction: column;

            & > div {
                display: flex;
                justify-content: space-between;
                
            }

            label {
                margin-top: 2.4rem;
            }
        }

        .btn {
            margin-left: 2rem;
        }

        .page-description img {
            height: 3.8rem;
            width: auto;
        }

        .routes div {
            width: 3.8rem;
            height: 3.8rem;
            background-color: #1E88E5;
            margin-right: 0.5rem;
            border-radius: 50%;
            color: white;
            font-size: 1.6rem;
            font-weight: 600;
            line-height: 3.9rem;
            text-align: center;

            &.red {
                background-color: #EE1D23;
            }
        }
    }
</style>